let $ = jQuery;
import Swiper from 'swiper';
import { Thumbs, Navigation } from 'swiper/modules';
// import 'swiper/swiper-bundle.min.css';
import { onViewChange } from "@/resources/assets/js/modules/utils";

Swiper.use([Navigation, Thumbs]);

class GalleryMini {

  constructor(node) {

    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this.viewer = this.root.querySelector('.GalleryProducts-viewer');
    this.viewerSlides = this.root.querySelectorAll('.GalleryProducts-viewer .swiper-slide');
    this.nav = this.root.querySelector('.GalleryProducts-nav');
    this.navSlides = this.root.querySelectorAll('.GalleryProducts-nav .swiper-slide');
    this.nextEl = this.root.querySelector('.GalleryProducts-pagination .next');
    this.prevEl = this.root.querySelector('.GalleryProducts-pagination .prev');
    this.pagination = this.root.querySelector('.GalleryProducts-pagination');
    this._init();

  }

  _init() {

    const swiperNav = new Swiper(this.nav, {
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      spaceBetween: 10,
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl,
      },
      breakpoints: {
        992: {
          slidesPerView: 5,
          spaceBetween: 20,
        }
      },
    });

    const swiper = new Swiper(this.viewer, {
      speed: 1300,
      autoplay: false,
      spaceBetween: 5,
      thumbs: {
        swiper: swiperNav,
      },
    });
    this._resizeContent();
    this._bindEvents();
    // this._lightbox();

  }

  _bindEvents() {
    onViewChange(this._resizeContent.bind(this));
  }

  _resizeContent() {
    setTimeout(() => {
      const viewerSlideWidth = this.viewerSlides[0].offsetWidth;
      const navSlideWidth = this.navSlides[0].offsetWidth;

      this.pagination.style.height = `${navSlideWidth}px`;
      this.viewerSlides.forEach(slide => {
        slide.style.height = `${viewerSlideWidth}px`;
      });

      this.navSlides.forEach(slide => {
        slide.style.height = `${navSlideWidth}px`;
      });
    }, 100);
  }

  _lightbox() {

    $(this.$root).find('[data-fancybox]').fancybox({
      infobar: false,
      loop: false,
      animationEffect: 'fade',
      transitionEffect: 'zoom-in-out',
      transitionDuration: 1000,
      buttons: [
        'zoom',
        'close'
      ]
    });

  }

  // _linkToProduct() {

  //   this.$variationsForm = jQuery('.variations_form.cart');
  //   if (!this.$variationsForm.length) return;

  //   this._recordInitialData();

  //   this.$variationsForm.on(
  //     'found_variation',
  //     this._updateSlide.bind(this)
  //   );

  //   this.$variationsForm.on(
  //     'reset_image',
  //     this._resetSlide.bind(this)
  //   );

  // }

  // _getFirstSlide(from) {

  //   if (!from.length) return {}
  //   return from.slick('getSlick').$slides[0];

  // }

  // _slideData(slide) {

  //   const isNode = 'querySelector' in slide;
  //   const withImg = isNode && slide.querySelector('img');

  //   return {
  //     src: isNode ? (withImg ? withImg.src : slide.querySelector('figure').style.backgroundImage) : '',
  //     full: isNode ? (withImg ? slide.dataset.src : slide.style.backgroundImage) : '',
  //     caption: isNode ? slide.dataset.caption : ''
  //   }

  // }

  // _recordInitialData() {

  //   this.initialData = {
  //     viewer: this._slideData(this._getFirstSlide(this.$viewer)),
  //     nav: this._slideData(this._getFirstSlide(this.$nav))
  //   };

  // }

  // _updateSlide(event, variation) {

  //   if (!variation.image.src) return;

  //   let firstSlide = this.$viewer.slick('getSlick').$slides[0];
  //   firstSlide.querySelector('img').src = variation.image.src;
  //   firstSlide.dataset.src = variation.image.url;
  //   variation.image.caption && (firstSlide.dataset.caption = variation.image.caption);
  //   this.$viewer.slick('slickGoTo', 0);

  //   if (this.$nav.length) {
  //     let firstNavSlide = this.$nav.slick('getSlick').$slides[0];
  //     firstNavSlide.querySelector('figure').style.backgroundImage = `url('${variation.image.gallery_thumbnail_src}')`;
  //     this.$nav.slick('slickGoTo', 0);
  //   }

  //   // $.fancybox.destroy();
  //   // this._lightbox();

  // }

  // _resetSlide() {

  //   let firstSlide = this.$viewer.slick('getSlick').$slides[0];
  //   firstSlide.querySelector('img').src = this.initialData.viewer.src;
  //   firstSlide.dataset.src = this.initialData.viewer.full;
  //   if (this.initialData.viewer.caption) {
  //     firstSlide.dataset.caption = this.initialData.viewer.caption;
  //   }

  //   if (this.$nav.length) {
  //     let firstNavSlide = this.$nav.slick('getSlick').$slides[0];
  //     firstNavSlide.querySelector('figure').style.backgroundImage = this.initialData.nav.src
  //   }

  // }

}

[...document.querySelectorAll('.GalleryProducts')].forEach(node => new GalleryMini(node));


jQuery("a.wc-toAdditional").click(function (event) {
  event.preventDefault();
  jQuery('html,body').animate({
    scrollTop: jQuery("#additionalProductInformation").offset().top - 235
  },
    'slow');
});